document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('.section_professional_table');
    const scrollbar = document.getElementById('custom-scrollbar');
    const thumb = document.getElementById('scrollbar-thumb');

    if (!section || !scrollbar || !thumb) return;

    let isDragging = false;
    let startX;
    let scrollLeft;

    function updateThumb() {
        const scrollWidth = section.scrollWidth - section.clientWidth;
        const thumbWidth = scrollbar.clientWidth - thumb.clientWidth;

        if (scrollWidth <= 0) {
            scrollbar.style.display = 'none';
        } else {
            scrollbar.style.display = 'block';
        }

        if (scrollWidth > 0) {
            const scrollPercent = section.scrollLeft / scrollWidth;
            const thumbLeft = scrollPercent * thumbWidth;
            thumb.style.transform = `translateX(${thumbLeft}px)`;
        }
    }

    section.addEventListener('scroll', updateThumb);

    thumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        scrollLeft = section.scrollLeft;
        thumb.style.cursor = 'grabbing';
        e.preventDefault();
    });

    document.addEventListener('mouseup', () => {
        isDragging = false;
        thumb.style.cursor = 'grab';
    });

    document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();

        const deltaX = e.clientX - startX;
        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = thumb.clientWidth;
        const maxTranslate = trackWidth - thumbWidth;
        const maxScroll = section.scrollWidth - section.clientWidth;

        if (maxTranslate > 0) {
            section.scrollLeft = scrollLeft + ((deltaX / maxTranslate) * maxScroll);
        }
    });

    thumb.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        scrollLeft = section.scrollLeft;
    });

    thumb.addEventListener('touchend', () => {
        isDragging = false;
    });

    thumb.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.touches[0].clientX;
        const walk = x - startX;

        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = thumb.clientWidth;
        const maxTranslate = trackWidth - thumbWidth;
        const maxScroll = section.scrollWidth - section.clientWidth;

        if (maxTranslate > 0) {
            section.scrollLeft = scrollLeft + ((walk / maxTranslate) * maxScroll);
        }
    });

    updateThumb();
    window.addEventListener('resize', updateThumb);
});